import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import Checkbox from '../components/Checkbox/Checkbox';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
import MultiRoleSwitch from '../components/MultiRoleSwitch/MultiRoleSwitch';
const SecurityAdminPassword = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [roles, setRoles] = useState({});   
    const [rolesArray, setRolesArray] = useState([]);   
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const results = await apiFetch({ path: '/ultimate-security/v1/get-roles' });
        
                // Save to localStorage
                localStorage.setItem("plusRoles", JSON.stringify(results));
        
                // Update state
                setRoles(results);
            } catch (error) {
                // console.error("Error fetching roles:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedRoles = localStorage.getItem("plusRoles");
        if (storedRoles) {
            setRoles(JSON.parse(storedRoles));
        } else {
            fetchRoles();
        }
    }, []);
    useEffect(() => {
        const tempArray = Object.entries(roles).length && Object.entries(roles).map(([code, { name, count }]) => ({
            label: name, // name
            value: code, // Use the key as the code
            hint: code === "administrator" ? __("This role is always active", "ultimate-security") : __("Enable/disable user role", "ultimate-security"),
            disabled: code === "administrator",
        }));
        setRolesArray(tempArray)
    }, [roles])
    // console.log(rolesArray);

    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Administrator Password", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("This option allows you to enable Administrator Password policies for your selected user role types. Allowed users will be able to log in to lower-level users using their own password.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable administrator password", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Administrator Password Use", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.use_admin_password.enable"
                                    checked={settingData?.security?.['use_admin_password']?.['enable']} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("User roles", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select which trusted user roles can log in to the accounts of lower-level users. See WordPress documentation for further ideas about user role hierarchy.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="title-group">
                            
                            <MultiRoleSwitch
                                settingData={settingData}
                                rolesArray={rolesArray}
                                handleChange={handleChange}
                            />
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityAdminPassword, 'security.use_admin_password');